import type { CaseOverlayTab } from '../types';

export const classes = {
  card: 'h-full grow min-w-[300px] overflow-x-auto px-3 pt-0 bg-gradient-to-br to-white from-blue-200/20 from-50%',
  tabsBlock: 'w-full flex flex-col flex-1 h-full',
  tabBody: 'flex-1 min-h-0 overflow-auto',
  adornment:
    'rounded-lg px-2 py-1 ml-2 bg-orange-3 text-white text-xs font-semibold place-center select-none',
};

export function getDefaultTab(searchParams: URLSearchParams) {
  let overlayTab = searchParams.get('caseOverlayTab');
  if (!overlayTab || !['files', 'settings'].includes(overlayTab)) {
    overlayTab = 'files';
  }
  return overlayTab as CaseOverlayTab;
}
